/* eslint-disable no-console */
import Button from "@app/components/move2Library/Button/Button"
import Input from "@app/components/move2Library/Input/Input"
import OrderLine from "@app/components/order/OrderLine/OrderLine"
import OrderLines from "@app/components/order/OrderLines/OrderLines"
import { PriceSummary } from "@app/components/order/PriceSummary/PriceSummary"
import TimeblockButton from "@app/components/order/TimeblockButton/TimeblockButton"
import Page from "@app/components/pageTypes/Page/Page"
import TerminalMessageModal from "@app/modals/funnel/TerminalMessage/TerminalMessageModal"
import { setZone, setZoneId } from "@app/store/actions/coreActions"
import { useRaiseError } from "@app/store/actions/errorActions"
import {
	addKioskVoucher,
	addVisitorKind,
	removeKioskVoucher,
	removeVisitorKind,
	setFormattedOrder,
	setSelectedTimeblockKind,
	setSelectedTimeslot,
} from "@app/store/actions/orderActions"
import { useGetLoungerTypes, useGetProducts, useGetUpsellArticles, useGetVouchers, useGetZones } from "@app/store/service/cmsService"
import { useCalendar, useFormatOrder, useGetVisitorKindRules, useGetVisitorKinds, useSaveOrder, useTimeblocks } from "@app/store/service/connectorService"
import { appStore } from "@app/store/store"
import { getDateString, getTimeString } from "@app/utils/localeUtils"
import { selectVisitorKindIds } from "@app/utils/selectors"
import { faChevronRight } from "@fortawesome/free-solid-svg-icons/faChevronRight"
import { faTrash } from "@fortawesome/free-solid-svg-icons/faTrash"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { classNamez, useModal } from "@tecreation/funnel-components"
import { useSelector } from "@tecreation/js-state-react"
import { useCallback, useEffect, useRef, useState } from "react"
import EmployeeFunnelPersonTypeSelector from "./EmployeeFunnelPersonTypeSelector"

import { Loader } from "@app/components/core/Loader/Loader"
import { ParkingTickets } from "@app/components/order/ParkingTickets/ParkingTickets"
import Vouchers from "@app/components/order/Vouchers/Vouchers"
import CashregisterUtilitiesModal from "@app/modals/CashregisterUtilitiesModal/CashregisterUtilitiesModal"
import EmployeeFunnelVoucherModal from "@app/modals/EmployeeFunnelVoucherModal"
import { ORDER_LINE_TYPES } from "@app/utils/constants"
import { KioskBridge } from "@tecreation/bird5-kiosk-bridge"
import "./EmployeeFunnel.css"
import getTbInfo from "./getTbInfo"

function CurrentDateTime() {
	const selectedDay = useSelector(state => state.order.selectedDay)

	const [realTime, setRealTime] = useState(new Date())

	useEffect(() => {
		const timer = setInterval(() => {
			setRealTime(new Date())
		}, 5 * 1000)
		return () => {
			clearInterval(timer)
		}
	})

	return (
		<div>
			{getDateString(selectedDay.dateObj)}, {getTimeString(realTime)}
		</div>
	)
}

function ZoneInformation({ count }) {
	return <div className="color-fg-secondary">Noch verfügbar: {count}</div>
}

function ZoneEntry({ zone, setZoneInfo, index, selectedZoneId, shouldRefetch }) {
	const selectedDay = useSelector(state => state.order.selectedDay.date)
	const locationId = useSelector(state => state.core.locationId)

	const [count, setCount] = useState(0)

	const [getCalendar] = useCalendar()

	const { data: visitorKindTypes, isLoading: __loading } = useGetVisitorKinds({ locationId, zoneId: zone.zoneId }, { skip: !zone.zoneId })

	useEffect(() => {
		if (!__loading) {
			getCalendar({
				locationId,
				zoneId: zone.zoneId,
				visitorKindIds: [{ visitorKindId: visitorKindTypes && visitorKindTypes.length ? visitorKindTypes[0].visitorKindId : -1, quantity: 1 }],
				dateFrom: selectedDay,
				dateTo: selectedDay,
			}).then(e => {
				if (e.data && e.data.length) {
					setCount(e.data[0].restCount || 0)
				} else {
					setCount(0)
				}
			})
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [shouldRefetch, locationId, zone, selectedDay, visitorKindTypes, __loading])

	return (
		<div
			className={
				"mb-2 zoneEntry" +
				classNamez({
					disabled: count === 0,
				})
			}
		>
			<div
				className="flex"
				onClick={() => {
					setZoneInfo(zone)
				}}
			>
				<input type="radio" name="zone" id={"zone" + index} checked={zone.zoneId === selectedZoneId} onChange={() => {}} />
				<label htmlFor={"zone" + index} className="ml-3 w-100">
					<div className="flex flex-justify-between">
						<div className="semibold">{zone.title}</div>
					</div>
				</label>
			</div>
			<div className="flex flex-justify-between">
				{/* <ZoneInformation zoneId={zone.zoneId} /> */}
				<div className="color-fg-secondary" />
				<ZoneInformation count={count} />
			</div>
		</div>
	)
}

export default function EmployeeFunnel() {
	const raiseError = useRaiseError()

	const selectedDay = useSelector(state => state.order.selectedDay)
	const locationId = useSelector(state => state.core.locationId)
	const zoneId = useSelector(state => state.core.zoneId)
	const visitorKinds = useSelector(state => state.order.visitorKinds)
	const visitorKindIds = useSelector(selectVisitorKindIds)
	const selectedTbKind = useSelector(state => state.order.selectedTbKind)
	const formattedOrder = useSelector(state => state.order.formattedOrder)
	const selectedTs = useSelector(state => state.order.selectedTs)
	const products = useSelector("order.products")
	const [saveOrder] = useSaveOrder()

	let d = new Date()
	const { data: visitorKindRules } = useGetVisitorKindRules({ date: d.toISOString().slice(0, 10) })

	const { data: zones } = useGetZones()
	const { data: visitorKindTypes, isLoading: __loading } = useGetVisitorKinds({ locationId, zoneId }, { skip: !zoneId })
	const { data: loungerTypes } = useGetLoungerTypes({ locationId: appStore.getState().core.locationId, zoneId })
	const { data: parkingTickets } = useGetUpsellArticles()
	const { data: baseProducts } = useGetProducts()
	//start already here the loading to that is already there in the voucher screen. Only for performance ;)
	useGetVouchers()

	const [getTimeblocks, { isFetching: __loadingTimeblocks, data: timeblockData }] = useTimeblocks()
	const [__formatOrder, { data: __formattedOrder, isLoading: formatLoading }] = useFormatOrder()
	const thermenCardRef = useRef(null)
	const { showModal, hideModal } = useModal()

	const [thermencard, setThermencard] = useState(undefined)
	const [cardError, setCardError] = useState(false)
	const [processing, setProcessing] = useState(false)

	const [__, updateState] = useState()
	// @ts-ignore
	const forceUpdate = useCallback(() => updateState(new Date().getTime()), [])

	useEffect(() => {
		if (visitorKindIds && zoneId && visitorKindIds.length) {
			getTimeblocks({ locationId, zoneId, visitorKindIds, dateString: selectedDay.date }).then(rsp => {
				if (selectedTbKind) {
					const found = rsp.data.find(e => e.timeBlockKindId == selectedTbKind.timeBlockKindId)
					if (found) {
						const { timeblock, timeslot } = getTbInfo(found)
						setSelectedTimeblockKind(found)
						if (timeblock && timeslot) {
							setSelectedTimeslot(timeslot, timeblock)
						} else {
							setSelectedTimeslot(undefined, timeblock)
						}
					}
				}
			})
		}
		if (visitorKindIds.length == 0) {
			appStore.set(state => ({
				order: {
					...state.order,
					formattedOrder: undefined,
				},
			}))
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [visitorKinds, zoneId])

	const formatOrder = useCallback((loungerTypes, parkingTickets, baseProducts) => {
		return __formatOrder()
			.unwrap()
			.then(rsp => {
				setFormattedOrder(rsp, loungerTypes, parkingTickets, baseProducts)
				return rsp
			})
			.catch(e => {
				raiseError(e, undefined, true)
			})
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	useEffect(() => {
		if (loungerTypes !== undefined && parkingTickets !== undefined && baseProducts !== undefined) {
			formatOrder(loungerTypes, parkingTickets, baseProducts)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [loungerTypes, parkingTickets, baseProducts])

	useEffect(() => {
		if (loungerTypes !== undefined && parkingTickets !== undefined && baseProducts !== undefined && selectedTs) {
			formatOrder(loungerTypes, parkingTickets, baseProducts)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [selectedTs, loungerTypes, parkingTickets, baseProducts])

	useEffect(() => {
		if (loungerTypes !== undefined && parkingTickets !== undefined && baseProducts !== undefined && products.length !== 0) {
			formatOrder(loungerTypes, parkingTickets, baseProducts)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [products, loungerTypes, parkingTickets, baseProducts])

	useEffect(() => {
		if (zoneId) {
			appStore.set(state => ({
				order: {
					...state.order,
					selectedTbKind: undefined,
					selectedTb: undefined,
					selectedTs: undefined,
					formattedOrder: undefined,
					priceActions: [],
					visitorKinds: [],
					products: [],
					parkingTickets: [],
				},
			}))
		}
	}, [zoneId])

	useEffect(() => {
		if (!thermencard) {
			thermenCardRef.current.value = ""
		}
	}, [thermencard])

	const pay = useCallback(
		async (paymentId, card, showEcMask, overrideFormattedOrder, relationId) => {
			try {
				let order = overrideFormattedOrder || formattedOrder

				if (showEcMask) {
					showModal(TerminalMessageModal)
				} else {
					setProcessing(true)
				}

				if (card) {
					if (card.amount <= 0 || card.amount < order.payAmount) {
						throw Error("Nicht genügend Guthaben!")
					}
				}

				let paymentLine = undefined
				if (order.payAmount > 0 && paymentId && !card) {
					paymentLine = await KioskBridge.execute(
						"payment.keyboard.kiosk",
						{
							paymentId: paymentId,
							payAmount: order.payAmount,
							relationId: relationId,
							addToReceipt: false,
						},
						message => {
							appStore.set(state => ({
								order: {
									...state.order,
									ecMessage: message,
								},
							}))
						},
					)
				} else if (order.payAmount > 0 && card) {
					order.paymentId = appStore.get("settings.employeeFunnelPayments.thermencard")
				}

				// let data = flatFormattedOrderForKisok(order, paymentLine)
				// await window.kiosk.method.execute("web.process.order", data)
				if (paymentLine && !paymentLine.paymentId) {
					paymentLine.paymentId = paymentId
				}
				const fo = await __formatOrder({ paymentLine }).unwrap()
				if (fo.payAmount > 0 && card) {
					fo.paymentId = card.paymentId
					fo.accountToken = card.accountToken
				}
				const swissbit = await KioskBridge.blackbox.getParams()
				if (swissbit) {
					await KioskBridge.blackbox.startTransaction(JSON.parse(JSON.stringify(fo)))
				}
				const startTransaction = await KioskBridge.blackbox.getCurrentTransaction()
				if (startTransaction) {
					const endTransaction = await KioskBridge.blackbox.endTransaction(startTransaction.order, startTransaction)
					fo.blackbox = {
						transactions: [startTransaction, endTransaction],
					}
				}
				appStore.set("order.formattedOrder", fo)
				const result = await saveOrder().unwrap()

				appStore.set(state => ({
					order: {
						...state.order,
						selectedTbKind: undefined,
						selectedTb: undefined,
						selectedTs: undefined,
						formattedOrder: undefined,
						visitorKinds: [],
						priceActions: [],
						parkingTickets: [],
						products: [],
					},
					core: {
						...state.core,
						zoneId: undefined,
					},
				}))
				setThermencard(undefined)
				setProcessing(false)
				hideModal()
				await KioskBridge.execute("printer.kiosk.print.receipt", { divisionId: result.divisionId }).catch(e => {
					console.error(e)
				})
				forceUpdate()

				if (appStore.get("core.kioskMode") || appStore.get("core.employeeMode")) {
					KioskBridge.execute("receipt.kiosk.stop").catch(() => {})
				}
			} catch (e) {
				console.log(e)
				raiseError(typeof e === "string" ? new Error(e) : e)
				setProcessing(false)
			}
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[formattedOrder],
	)

	return (
		<Page style={{ backgroundColor: "#efefef" }} className="p-4">
			{processing && (
				<div className="absolute top-0 left-0 w-100 h-100 flex flex-center z-9" style={{ backgroundColor: "rgba(0,0,0,.6)" }}>
					<Loader show={processing} />
				</div>
			)}

			<div className="boxShadow h-100 flex flex-column color-bg-default">
				<div className=" px-4 pt-4 scrollable ">
					<div className="flex">
						<div className="flex-1 mr-4">
							<div className="f3">Datum</div>
							<CurrentDateTime />
						</div>
						<div className="flex-1">
							<div>
								<div className="f3 mb-3">Thermencard</div>
								<div className="flex relative">
									<Input
										placeholder="Thermencard"
										readOnly={thermencard !== undefined}
										className={
											"w-100" +
											classNamez({
												"color-bg-red-100": cardError && thermenCardRef.current && thermenCardRef.current.value,
												"color-bg-green-100": !cardError && thermencard,
											})
										}
										inputRef={thermenCardRef}
										onKeyUp={async e => {
											if (e.key === "Enter" || e.keyCode === 13) {
												if (thermenCardRef.current.value.length) {
													try {
														setThermencard(e)
														setCardError(false)
													} catch (e) {
														setThermencard(true)
														setCardError(true)
														raiseError(new Error(e))
													}
												}
											}
										}}
									/>
									{thermencard && (
										<div
											className="flex flex-center f3 absolute clickable h-100"
											style={{ right: "90px" }}
											onClick={() => {
												setThermencard(undefined)
											}}
										>
											<FontAwesomeIcon icon={faTrash} />
										</div>
									)}

									<Button
										style="primary"
										className="ml-2"
										onClick={async () => {
											if (thermenCardRef.current.value.length) {
												try {
													let r = await KioskBridge.execute("bank.account.scan", { scanCode: thermenCardRef.current.value })
													setThermencard(r)
													setCardError(false)
												} catch (e) {
													setThermencard(undefined)
													setCardError(true)
													raiseError(new Error(e))
												}
											}
										}}
									>
										<FontAwesomeIcon icon={faChevronRight} />
									</Button>
								</div>
							</div>
						</div>
					</div>

					<div className="w-100 flex">
						<div className="flex-1 mr-4">
							{/* ZoneSelecttion */}

							<div className="mt-6">
								<div className="f3 mb-3">Bereich</div>
								{zones && (
									<div>
										{zones.map((zone, index) => {
											return (
												<ZoneEntry
													zone={zone}
													index={index}
													shouldRefetch={__}
													selectedZoneId={zoneId}
													setZoneInfo={zone => {
														setZone(zone)
														setZoneId(zone.zoneId)
													}}
													key={index}
												/>
											)
										})}
									</div>
								)}
							</div>

							{/* Ticket Selection */}
							<div className="mt-6">
								<div className="f3 mb-3">Ticket</div>
								<Loader show={__loadingTimeblocks} />
								{!__loadingTimeblocks && timeblockData && visitorKindIds.length > 0 && (
									<div className="flex flex-items-baseline" style={{ gap: "16px" }}>
										{timeblockData.map((tb, index) => {
											const { timeblock, timeslot, nextTime } = getTbInfo(tb)
											let disabled = !timeblock
											return (
												<div className="w-100" key={index}>
													<TimeblockButton
														fillWidth
														type={tb.type}
														price={timeblock?.price}
														showFrom={false}
														onClick={() => {
															if (!timeslot) {
																setFormattedOrder(undefined)
																setSelectedTimeblockKind(undefined)
																raiseError(new Error("Kein verfügbarer Slot!"))
																return
															}

															setSelectedTimeblockKind(tb)
															if (timeblock && timeslot) {
																setSelectedTimeslot(timeslot, timeblock)
															}
														}}
														selected={selectedTbKind && selectedTbKind.type == tb.type}
														disabled={__loadingTimeblocks || disabled}
													/>

													{!timeslot && nextTime && <div className="text-center">Verfügbar ab {nextTime}</div>}
												</div>
											)
										})}
									</div>
								)}
								{!__loadingTimeblocks && timeblockData && timeblockData.length == 0 && visitorKindIds.length > 0 && (
									<div className="color-fg-danger">Keine Tickets verfügbar</div>
								)}
								{!__loadingTimeblocks && visitorKindIds.length == 0 && <div className="color-fg-danger">Bitte wählen Sie die Personen</div>}
							</div>
						</div>
						<div className="flex-1">
							{/* Personenanzahl */}
							<div className="mt-6">
								<div className="f3 mb-3">Personenanzahl</div>
								{visitorKindTypes &&
									visitorKindRules &&
									visitorKindTypes
										.filter(v => {
											let id = v.visitorKindId
											let restricted = visitorKindRules.find(
												e =>
													e.zoneId === zoneId &&
													e.visitorKindIds.length == 1 &&
													e.visitorKindIds[0] === id &&
													e.errorMessage &&
													(e.errorMessage.startsWith("wrn.VisitorKindRule.NoAccess") || e.errorMessage.startsWith("wrn.VisitorKind.NoAccess")),
											)
											return restricted ? false : true
										})
										.map((visitorKind, index) => {
											return (
												<EmployeeFunnelPersonTypeSelector
													count={visitorKinds[visitorKind.visitorKindId] ? visitorKinds[visitorKind.visitorKindId].cnt : 0}
													text={visitorKind.title}
													subText={visitorKind.subTitle}
													key={index}
													onAdd={() => {
														addVisitorKind(visitorKind)
													}}
													onRemove={() => removeVisitorKind(visitorKind)}
												/>
											)
										})}
							</div>

							<div className="mt-6">
								{/* <div className="f3 mb-3">Leistungen</div> */}
								<ParkingTickets
									formattedOrder={formattedOrder}
									onAction={() => {
										formatOrder(loungerTypes, parkingTickets, baseProducts)
									}}
								/>
							</div>

							<div className="mt-6">
								<div className="f3 mb-3">Leistungen</div>
								{formattedOrder && formattedOrder.orderLines.length > 0 && (
									<>
										<OrderLines>
											{formattedOrder.orderLines.map((e, index) => {
												if (e.details[0].typeId === ORDER_LINE_TYPES.VoucherDetail) {
													return null
												}
												if (e.details[0].typeId === ORDER_LINE_TYPES.Voucher) {
													return (
														<OrderLine
															orderLine={e}
															key={index}
															isEditable
															onPlus={() => {
																addKioskVoucher(e)
															}}
															onMinus={() => {
																removeKioskVoucher(e)
															}}
															showMinus
														/>
													)
												} else {
													return <OrderLine orderLine={e} key={index} />
												}
											})}
										</OrderLines>
										<Vouchers
											formattedOrder={formattedOrder}
											onAction={() => {
												formatOrder(loungerTypes, parkingTickets, baseProducts)
											}}
										/>
										<PriceSummary formattedOrder={formattedOrder} />
									</>
								)}
							</div>
						</div>
					</div>
				</div>
				<div className="p-3 w-100 mt-auto color-bg-default flex flex-justify-between" style={{ backgroundColor: "#efefef" }}>
					<div className="flex">
						<Button
							style="outlined"
							className="primary"
							onClick={() => {
								try {
									KioskBridge.execute("index.close")
								} catch (e) {
									raiseError(typeof e === "string" ? new Error(e) : e)
								}
							}}
						>
							Schließen
						</Button>
						<Button
							style="outlined"
							className="primary ml-3"
							onClick={() => {
								showModal(CashregisterUtilitiesModal)
							}}
						>
							Options
						</Button>
						<Button
							style="outlined"
							className="primary ml-3"
							onClick={() => {
								try {
									KioskBridge.execute("cashDrawer.kiosk.open")
								} catch (e) {
									raiseError(typeof e === "string" ? new Error(e) : e)
								}
							}}
						>
							Kassenschublade öffnen
						</Button>
						<Button
							style="outlined"
							className="primary ml-3"
							onClick={() => {
								showModal(EmployeeFunnelVoucherModal)
							}}
						>
							Gutscheine
						</Button>
						{appStore.get("settings.employeeFunnelInstantVoucherConfig") && (
							<Button
								style="outlined"
								className="primary ml-3"
								onClick={() => {
									addKioskVoucher(appStore.get("settings.employeeFunnelInstantVoucherConfig"))
									formatOrder(loungerTypes, parkingTickets, baseProducts)
										.then(e => {
											/**
											 * Break out of the render stack otherwhise formattedOrder is undefined
											 */
											pay(
												appStore.get("settings.employeeFunnelInstantVoucherConfig.paymentId"),
												undefined,
												false,
												e,
												appStore.get("settings.employeeFunnelInstantVoucherConfig").relationId,
											)
										})
										.catch(() => {
											removeKioskVoucher(appStore.get("settings.employeeFunnelInstantVoucherConfig"))
										})
								}}
							>
								Instant Voucher
							</Button>
						)}
					</div>

					<div className="flex">
						{!thermencard && (
							<>
								<Button
									style="secondary"
									disabled={!formattedOrder || formatLoading || formattedOrder.orderLines.length === 0}
									onClick={() => {
										pay(appStore.get("settings.employeeFunnelPayments.ec"), undefined, true)
									}}
								>
									Bezahlen EC
								</Button>
								<Button
									style="secondary"
									disabled={!formattedOrder || formatLoading || formattedOrder.orderLines.length === 0}
									className="ml-3"
									onClick={() => {
										pay(appStore.get("settings.employeeFunnelPayments.cash"))
									}}
								>
									Bezahlen BAR
								</Button>
							</>
						)}
						{thermencard && (
							<>
								<Button
									style="secondary"
									disabled={!formattedOrder || formatLoading || formattedOrder.orderLines.length === 0}
									onClick={() => {
										pay(appStore.get("settings.employeeFunnelPayments.thermencard"), thermencard)
									}}
								>
									Bezahlen Thermencard
								</Button>
							</>
						)}
					</div>
				</div>
			</div>
		</Page>
	)
}
